import type { ButtonDesignTokens } from '@primeuix/themes/types/button';

export const buttonPreset: ButtonDesignTokens = {
  root: {
    borderRadius: '{borderRadius}',
    paddingX: '16px',
    paddingY: '7px',
    sm: {
      paddingX: '16px',
      paddingY: '7px',
    },
  },

  colorScheme: {
    dark: {
      root: {
        primary: {
          background: '{nspOcean.400}',
          hoverBackground: '{nspOcean.300}',
          activeBackground: '{nspOcean.200}',
          borderColor: '{nspOcean.400}',
          hoverBorderColor: '{nspOcean.300}',
          activeBorderColor: '{nspSky.300}',
          color: '{nspSlate.0}',
          hoverColor: '{nspSlate.0}',
          activeColor: '{nspSlate.0}',
          focusRing: {
            color: '{focusRing.color}',
          },
        },
        secondary: {
          background: '{nspSlate.500}',
          hoverBackground: '{nspSlate.300}',
          activeBackground: '{nspSlate.200}',
          borderColor: '{nspSlate.500}',
          hoverBorderColor: '{nspSlate.300}',
          activeBorderColor: '{nspSky.300}',
          color: '{nspSlate.0}',
          hoverColor: '{nspSlate.0}',
          activeColor: '{nspSlate.0}',
          focusRing: {
            color: '{focusRing.color}',
          },
        },
      },
      outlined: {
        primary: {
          hoverBackground: '{nspSlate.600}',
          activeBackground: '{nspSlate.500}',
          borderColor: '{nspSlate.200}',
          color: '{nspSlate.0}',
        },
      },
      text: {
        primary: {
          hoverBackground: '{nspSlate.600}',
          activeBackground: '{nspSlate.500}',
          color: '{nspSlate.0}',
        },
      },
    },
    light: {
      root: {
        primary: {
          background: '{nspOcean.400}',
          hoverBackground: '{nspOcean.500}',
          activeBackground: '{nspOcean.600}',
          borderColor: '{nspOcean.400}',
          hoverBorderColor: '{nspOcean.500}',
          activeBorderColor: '{nspSky.300}',
          color: '{nspSlate.0}',
          hoverColor: '{nspSlate.0}',
          activeColor: '{nspSlate.0}',
          focusRing: {
            color: '{focusRing.color}',
          },
        },
        secondary: {
          background: '{nspMist.200}',
          hoverBackground: '{nspMist.300}',
          activeBackground: '{nspMist.400}',
          borderColor: '{nspMist.200}',
          hoverBorderColor: '{nspSky.300}',
          activeBorderColor: '{nspSky.300}',
          color: '{nspMist.800}',
          hoverColor: '{nspMist.900}',
          activeColor: '{nspMist.900}',
          focusRing: {
            color: '{focusRing.color}',
          },
        },
      },
      outlined: {
        primary: {
          hoverBackground: '{nspMist.100}',
          activeBackground: '{nspMist.200}',
          borderColor: '{nspSlate.200}',
          color: '{nspSlate.200}',
        },
      },
      text: {
        primary: {
          hoverBackground: '{nspMist.100}',
          activeBackground: '{nspMist.200}',
          color: '{nspSlate.200}',
        },
      },
    },
  },
  css: ({ dt }) => `
    .p-button {
      line-height: 1.3;
    }

    .p-button-secondary:disabled {
      background: ${dt('nspSlate.700')};
      color: ${dt('nspSlate.100')};
      opacity: 1;
    }

    .p-button-outlined:disabled {
      border-color: ${dt('nspSlate.400')};
      color: #5B7386;
      opacity: 1;
    }

    .p-button-text:disabled {
      color: #5B7386;
      opacity: 1;
    }

    p-button:active,
    .p-button-active {
      &:not(:disabled) {
        &.p-button-outlined,
        &.p-button-text {
          border: solid 1px ${dt('nspSky.300')};
        }

        &:not(:hover) {
          background: ${dt('button.activeBackground')};

          &.p-button-secondary {
            background: ${dt('button.secondary.activeBackground')};
          }

          &.p-button-outlined {
            background: ${dt('button.outlined.primary.activeBackground')};
          }

          &.p-button-text {
            background: ${dt('button.text.primary.activeBackground')};
          }
        }
      }
    }
  `,
};
